export const tokenizeMetal = (value?: string): string[] => {
  if (!value) return [];
  return value
    .toLowerCase()
    .replace(/[^a-z]+/g, ' ')
    .split(' ')
    .map((token) => token.trim())
    .filter(Boolean);
};

const classifyTokens = (tokens: string[]): boolean | null => {
  if (!tokens.length) return null;
  const hasGold = tokens.includes('gold');
  if (!hasGold) return false;
  if (tokens.includes('non')) return false;
  return true;
};

export const isGoldFromSelection = (metalType?: string, fallbackProductId?: string): boolean => {
  const tokens = tokenizeMetal(metalType);
  const result = classifyTokens(tokens);
  if (result !== null) {
    return result;
  }
  return Boolean(fallbackProductId?.endsWith?.('-G'));
};

export const isGoldFromAttributes = (
  attributes: { name?: string; value?: string }[] | undefined,
  fallbackProductId?: string
): boolean => {
  const metalAttr = attributes?.find?.((attr) => attr?.name?.toLowerCase() === 'metal');
  const tokens = tokenizeMetal(metalAttr?.value);
  const result = classifyTokens(tokens);
  if (result !== null) {
    return result;
  }
  return Boolean(fallbackProductId?.endsWith?.('-G'));
};
